import styles from './Summary.module.scss';
import useVehicleInteraction from '../useVehicleInteraction';
import MapView from '@customer/components/maps/map-view/MapView';
import InteractionObjects from '@customer/components/maps/interaction-objects/InteractionObjects';
import usePositionsOnMap from '@customer/components/maps/hooks/usePositionsOnMap';
import InteractionSummaryVI from '@customer/components/data-display/interaction-summary-vi/InteractionSummaryVI';

export function Summary() {
  const { interaction } = useVehicleInteraction();

  const { lo, ro } = interaction ?? {};

  const mapProps = usePositionsOnMap([lo?.startPos, ro?.startPos]);

  return (
    <div className={styles.container}>
      <InteractionSummaryVI interaction={interaction} />

      <div className={styles.map}>
        <MapView {...mapProps} showLayersControl={true}>
          {lo && <InteractionObjects lo={lo} ro={ro} />}
        </MapView>
      </div>
    </div>
  );
}

export default Summary;
